import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output
       } from '@angular/core';

import { TextConstants } from 'app/text/text.constants';
import { Utils } from '../../core/utils';

@Component({
    selector: 'text-size-chooser',
    templateUrl: './text-size-chooser.component.html',
    styleUrls: ['./text-size-chooser.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TextSizeChooserComponent
{
  @Input('minDisplayFontSize') public minDisplayFontSize: number =
      TextConstants.MIN_FONT_SIZE;
  @Input('maxDisplayFontSize') public maxDisplayFontSize: number =
      TextConstants.MAX_FONT_SIZE;
  @Input('enabled') public enabled: boolean = false;
  @Output() public fontSizeChange: EventEmitter<number> = new EventEmitter();
  public _fontSize: number = 0;

  @Input('fontSize') public set fontSize(value: number)
  {
    this._fontSize = Math.round(value);
  }

  public setFontSize(size: number): void
  {
    this.fontSizeChange.emit(Math.round(size));
  }
}
